<template>
  <div v-show="menuVisible">
    <ul id="menu_right" class="menu_right">
      <li
        class="menu_right__item"
        v-for="(item, index) in title"
        :key="index"
        @click="append(clickNode, item)"
      >
        {{ item.title }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "tree-right-menu",
  components: {},
  props: ["title"],
  data() {
    return {
      clickNode: "",
      menuVisible: false,
    };
  },

  watch: {},
  mounted() {
    // 点击其他地方释放
    document.querySelector("body").removeEventListener("click", (e) => {
      if (e.target.className.indexOf("el-aside") < 0) {
        this.menuVisibleHide();
      }
    });
    document.querySelector("body").addEventListener("click", (e) => {
      if (e.target.className.indexOf("el-aside") < 0) {
        this.menuVisibleHide();
      }
    });
  },
  methods: {
    rightClick(MouseEvent, object, Node, element) {
      // 鼠标右击触发事件
      // console.log(object.id, this.$GLOBAL.map.getLayer(object.id, "modelId"));
      this.menuVisible = false; // 先把模态框关死，目的是 第二次或者第n次右键鼠标的时候 它默认的是true
      if (object.children.length == 0 && Node.checked) {
        let menu = document.querySelector("#menu_right");
        // element.handleClick();
        if (this.$GLOBAL.map.getLayer(object.id, "modelId") == undefined) {
          this.$notify({
            title: "模型不可见",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        }
        this.menuVisible = true; // 显示模态窗口，跳出自定义菜单栏
        menu.style.left = MouseEvent.clientX + 3 + "px"; // MouseEvent.clientX获取鼠标点击的坐标，在该处新增加的menu填充的位置
        menu.style.top = MouseEvent.clientY - 3 + "px";
        document.addEventListener("click", this.foo); // 给整个document添加监听鼠标事件，点击任何位置执行foo方法
        this.clickNode = Node; //存储待操作的节点或删除、或在该层或子层添加节点
      }
    },
    menuVisibleHide() {
      this.menuVisible = false;
    },
    menuVisibleShow() {
      this.menuVisible = true;
    },
    append(data, item) {
      this.menuVisibleHide();
      if (item.key == "Details") this.$emit("confirm", data);
      if (item.key == "Edit") this.$emit("editModel", data);
    },
  },
};
</script>

<style lang="scss" scoped>
.menu_right {
  font-size: 1.2rem;
  color: #dfe3ff;
  list-style: none;
  margin: 0;
  padding: 0.05em 0.25em;
  // border: 1px solid transparent;
  // border-right-color: rgba(255, 255, 255, 0.15);
  // border-bottom-color: rgba(255, 255, 255, 0.15);
  // border-left-color: rgba(0, 0, 0, 0.15);
  // border-top-color: rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  position: absolute;
  min-width: 16em;
  z-index: 9998;
  // background: linear-gradient(135deg, #2cb4ff 50%, #99c6ff 83%, #ded2ff);
  background: -webkit-radial-gradient(
      0% 100%,
      ellipse cover,
      rgba(104, 128, 138, 0.4) 10%,
      rgba(138, 114, 76, 0) 40%
    ),
    linear-gradient(
      to bottom,
      rgba(57, 173, 219, 0.25) 0%,
      rgba(42, 60, 87, 0.4) 100%
    ),
    linear-gradient(135deg, #670d10 0%, #092756 100%);
  box-shadow: 2px 5px 16px -4px #141321;
  transition-duration: 0.5s, 0.2s, 0.4s, 0.3s;
  transition-delay: 0.1s, 0s, 0.4s, 0.2s;
  transition-timing-function: ease;
  opacity: 1;
  transform: none;
  transition-delay: 0s, 0s, 0s, 0s;
  visibility: visible;
  filter: none;
}
.menu_right,
.menu_right * {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: default;
}
.menu_right.is-visible {
  opacity: 1;
  transform: none;
  transition-delay: 0s, 0s, 0s, 0s;
  visibility: visible;
  filter: none;
}
.menu_right.sub {
  background: var(--color2);
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  min-width: 10em;
  left: 100%;
  top: -0.4em;
  transform: translateX(-0.7em);
  transition: transform, opacity, width, min-width, visibility;
  transition-timing-function: ease;
  transition-duration: 0.4s, 0.25s, 0.15s, 0.15s, 0.01s;
  transition-delay: 0.4s, 0.25s, 0.3s, 0.3s, 0.35s;
  overflow: hidden;
  filter: none;
}
.menu_right.sub .f {
  transform: translateX(-2.25em);
}
.menu_right.sub.oppositeX {
  right: 100%;
  left: auto;
  transform: translateX(0.7em);
}
.menu_right.sub.oppositeY {
  top: auto;
  bottom: -0.4em;
}
.menu_right > li {
  padding: 0.3em 2.8em 0.35em 1.5em;
  border-radius: 3px;
  position: relative;
  cursor: pointer;
  &:hover {
    // font-weight: bold;
    color: white;
  }
}
.menu_right > li:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  border-radius: 3px;
  z-index: -1;
  background-color: rgba(97, 97, 97, 0.37);
  mix-blend-mode: color-dodge;
  transition: opacity 0.15s cubic-bezier(0.55, 0.06, 0.68, 0.19);
  opacity: 0;
}
.menu_right > li.hilight {
  font-weight: 500;
  padding-bottom: 0.5em;
  color: white;
}
.menu_right > li:not(.menu_right > li.nope):hover {
  color: white;
}
.menu_right > li:not(.menu_right > li.nope):hover:before {
  opacity: 1;
  transition: opacity 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.menu_right > li:not(.menu_right > li.nope):hover .sub {
  opacity: 1;
  transform: translateX(0);
  transition-delay: 0.2s, 0.25s, 0.2s, 0.2s, 0s;
  border-radius: 0 3px 3px 3px;
  visibility: visible;
}
.menu_right > li:hover > .f,
.menu_right > li.hilight > .f {
  opacity: 1;
}
.menu_right > li:last-child {
  margin-bottom: 0.25em;
}
.menu_right > li:first-child {
  margin-top: 0.25em;
}
.menu_right > li.nope {
  color: rgba(255, 255, 255, 0.3);
}
.menu_right > li.active {
  -webkit-animation: flash 0.5s ease 1;
  animation: flash 0.5s ease 1;
}
.menu_right > li:nth-of-type(1) {
  margin-top: 0.5em;
}
.menu_right > li .f {
  opacity: 0.5;
  transition: all 0.2s ease;
}
.menu_right > li i {
  font-style: normal;
  text-decoration: underline;
  -webkit-text-decoration-color: rgba(255, 255, 255, 0.35);
  text-decoration-color: rgba(255, 255, 255, 0.35);
}
.menu_right .div {
  border-bottom: 1px solid var(--divider);
  padding: 0;
  margin-top: 0.3em;
  margin-bottom: 0.35em;
}
.menu_right .f {
  font-style: normal;
  position: absolute;
  transform: translateX(-2.4em);
}
.menu_right .f[class*="chevron-right"] {
  right: 0;
  transform: none;
}

.f.f-circle {
  fill: red;
}

span.size {
  position: absolute;
  font-size: 0.675em;
  left: 1.2em;
  top: 0.8em;
  text-shadow: aliceblue;
}

@-webkit-keyframes flash {
  0% {
    background: rgba(255, 255, 255, 0);
  }
  7% {
    background: rgba(255, 255, 255, 0.2);
  }
  14% {
    background: rgba(255, 255, 255, 0);
  }
  21% {
    background: rgba(255, 255, 255, 0.3);
  }
}

@keyframes flash {
  0% {
    background: rgba(255, 255, 255, 0);
  }
  7% {
    background: rgba(255, 255, 255, 0.2);
  }
  14% {
    background: rgba(255, 255, 255, 0);
  }
  21% {
    background: rgba(255, 255, 255, 0.3);
  }
}
*,
*:after,
*:before {
  box-sizing: border-box;
}
</style>
